import './src/vaadin-crud.js';
export * from './src/vaadin-crud.js';
